import { jsx as l } from "react/jsx-runtime";
import "react";
var a = (r) => /* @__PURE__ */ l("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 36 36",
  ...r,
  children: /* @__PURE__ */ l("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M15.978 4C9.363 4 4 9.363 4 15.978c0 6.615 5.363 11.978 11.978 11.978 2.625 0 5.053-.844 7.027-2.276l5.951 5.95a1.26 1.26 0 0 0 1.783 0l.892-.89a1.26 1.26 0 0 0 0-1.784l-5.951-5.95a11.925 11.925 0 0 0 2.276-7.028C27.956 9.363 22.593 4 15.978 4ZM7.783 15.978a8.196 8.196 0 1 1 16.39 0 8.196 8.196 0 0 1-16.39 0Z",
    clipRule: "evenodd"
  })
});
export {
  a as default
};
